import React from 'react';
import FieldsetContent from './FieldsetContent';
import LineChart from '../lineChart/LineChart';
import Table from '../table/Table';
import Alert from '../alert/Alert'
import { saveData } from '../../helpers/axios/Post'
import { connect } from 'react-redux';
import {
  HOST_URL,
  POST_PROJECT_DATA,
  POST_PROJECT_DATA_SUCCESS,
  POST_PROJECT_DATA_ERROR,
  POST_CALCULATIONS,
  POST_CALCULATIONS_ERROR,
  POST_CALCULATIONS_SUCCESS,
} from '../../helpers/constants/Constants';
import {
  postRequest
} from '../../helpers/axios/Post'

class Form extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      success: false,
      running: false,
      failed: false,
      valid: false,
      id: this.props.content.form_id + "_form",
      isCalculationForm: this.props.isCalculationForm,
      content: [],
      inputs: {
      }
    }
  }

  findValue = (inputValues, key) => {
    return inputValues.find(value => value.category === key).value;
  }

  getResponse = (response) => {
    if (response.status === 200) {
      this.setState({
        success: true,
        running: false
      })
      if (this.state.isCalculationForm) {
        this.props.onrequestPostCalculations({
          method: 'post',
          url: HOST_URL + '/api/getcalculationdata',
          headers: { 'content-type': 'application/json' },
          withCredentials: true,
          data: {
            projectid: this.props.selectedProject.projectid
          }
        })
      } else {
        this.props.onrequestPostProjectData({
          method: 'post',
          url: HOST_URL + '/api/getprojectinput',
          headers: { 'content-type': 'application/json' },
          withCredentials: true,
          data: {
            projectid: this.props.selectedProject.projectid
          }
        })
      }
    } else {
      this.setState({
        failed: true,
        running: false
      })
    }
  }

  initializedCall = () => {
    this.setState({
      running: true
    })
  }

  renderSavedState = () => {
    if (this.state.running) {
      let run = this.state.isCalculationForm ? this.props.settings.formMssgRunning.fme : this.props.settings.formMssgRunning.saved;
      run = run.replace('{title}', this.props.formTitle)
      return <Alert alertMessage={run} alertType={'alert-info'} />
    } else if (this.state.success) {
      let success = this.state.isCalculationForm ? this.props.settings.formMssgSuccess.fme : this.props.settings.formMssgSuccess.saved;
      success = success.replace('{title}', this.props.formTitle)
      return <Alert alertMessage={success} alertType={'alert-success'} />
    } else if (this.state.failed) {
      let failed = this.state.isCalculationForm ? this.props.settings.formMssgFailed.fme : this.props.settings.formMssgFailed.saved;
      failed = failed.replace('{title}', this.props.formTitle)
      return <Alert alertMessage={failed} alertType={'alert-danger'} />
    }
  }

  onSubmit = (e, runCalculationJob = false) => {
    e.preventDefault()
    const { project_id, fmejob, form_id } = this.props.content
    const { isCalculationForm } = this.state;

    const form = document.getElementById(form_id + '_form');
    const inputElements = form.querySelectorAll('input');
    const selectElements = form.querySelectorAll('select');

    let data = [];
    let flow_data = null;
    let isFlowData = form_id === 'flow_data' ? true : false;

    if (isFlowData) {
      flow_data = { percentiles: inputElements[0].value }
    } else {
      inputElements.forEach(inputElement => {
        data.push({ category: inputElement.id, value: inputElement.value })
      })
      selectElements.forEach(selectElement => {
        data.push({ category: selectElement.id, value: selectElement.value })
      })
    }

    let endpoint = isCalculationForm ? '/api/savecalculationdata' : '/api/saveprojectinput';
    const config = {
      method: 'post',
      url: HOST_URL + endpoint,
      headers: { 'content-type': 'application/json' },
      withCredentials: true,
      data: {
        projectid: project_id,
        category: form_id,
        fmejob: ((runCalculationJob && isCalculationForm) || (!isCalculationForm && fmejob !== null) ? fmejob : null),
        data: isFlowData ? flow_data : data,
        fileType: isCalculationForm ? this.props.settings.calculationsExtension : null
      }
    };

    if (runCalculationJob) {
      config.data.userId = this.props.user.id;
    }

    saveData(config, this.getResponse, this.initializedCall)
  }

  runCalculation = (e) => {
    e.preventDefault();
    this.onSubmit(e, true)
  }

  static getDerivedStateFromProps(nextProps) {
    let { data_from_db, field_sets } = nextProps.content

    if (data_from_db !== undefined) {
      let data = data_from_db.data !== undefined ? JSON.parse(data_from_db.data) : null;
      let content = field_sets.map(fieldset => {
        let inputs = fieldset.input_fields.map((config) => {
          if (data) {
            let formData = Array.isArray(data) ? data.find(object => object.category === config.key) : []
            config.data_from_db = formData ? formData : []
          } else {
            config.data_from_db = []
          }
          return config
        })
        fieldset.input_fields = inputs
        return fieldset
      });
      return { content: content }
    }
    return { content: field_sets }
  }

  compStatusCheck = (obj) => {
    this.setState(prevState => ({
      inputs: {
        ...prevState.inputs,
        ...obj
      }
    }))
  }

  componentDidUpdate() {
    let status = true;
    for (const obj in this.state.inputs) {
      if (status) {
        status = this.state.inputs[obj]
      }
    }
    if (status !== this.state.valid) {
      this.setState({
        valid: status
      })
    }
  }

  render() {
    const { form_id, project_id, data_from_db } = this.props.content;
    const { content, isCalculationForm, valid } = this.state;
    const formData = data_from_db ? data_from_db.data ? JSON.parse(data_from_db.data) : [] : [];

    return (
      <>
        <form
          method="post"
          encType="multipart/form-data"
          id={form_id + '_form'}
          onSubmit={this.onSubmit}>
          <fieldset>
            {
              content.length === 1 ?
                <FieldsetContent
                  projectId={project_id}
                  content={content[0].input_fields}
                  field_set_description={content[0].field_set_description}
                  fieldsetAlias={content[0].field_set_alias}
                  key={this.state.id + '-' + project_id + '-' + content[0].field_set_id + '-' + 0}
                  fieldsetId={content[0].field_set_id}
                  getResponse={this.getResponse}
                  initializedCall={this.initializedCall}
                  id={content[0].field_set_id}
                  compStatusCheck={this.compStatusCheck}
                  combinedValidation={content[0].combined_validation}
                /> :
                content.map((fieldset, i) => {
                  return (
                    <fieldset key={this.state.id + '-' + project_id + '-' + fieldset.field_set_id + '-' + i} >
                      <FieldsetContent
                        projectId={project_id}
                        content={fieldset.input_fields}
                        field_set_description={fieldset.field_set_description}
                        fieldsetAlias={fieldset.field_set_alias}
                        fieldsetId={fieldset.field_set_id}
                        getResponse={this.getResponse}
                        initializedCall={this.initializedCall}
                        id={fieldset.field_set_id}
                        compStatusCheck={this.compStatusCheck}
                        combinedValidation={fieldset.combined_validation}
                      />
                    </fieldset>
                  )
                })
            }
            <div className="row">
              <div className="col">
                <div className="btn-group-form">
                  {
                    isCalculationForm &&
                    <button type="submit" disabled={!valid} onClick={this.runCalculation} className="btn btn-secondary">Run calculation</button>
                  }
                  <button type="submit" disabled={!valid} className="btn btn-primary">Save</button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                {
                  this.renderSavedState()
                }
              </div>
            </div>
          </fieldset>
        </form>
        {
          formData && form_id === 'flow_data' ? <LineChart size={this.props.size} projectData={formData} show={this.props.show} /> : ''
        }
        {
          form_id === 'sampling_data' &&
          <div>
            {
              formData &&
              formData.map((tableContent, i) => <Table content={tableContent} key={project_id + '-' + tableContent.key + '-' + i} />)
            }
          </div>
        }
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onrequestPostProjectData: (config) => dispatch(postRequest(
      {
        pending: POST_PROJECT_DATA,
        error: POST_PROJECT_DATA_ERROR,
        success: POST_PROJECT_DATA_SUCCESS
      },
      config
    )),
    onrequestPostCalculations: (config) => dispatch(postRequest(
      {
        pending: POST_CALCULATIONS,
        error: POST_CALCULATIONS_ERROR,
        success: POST_CALCULATIONS_SUCCESS
      },
      config
    ))
  }
}

const mapStateToProps = (state) => ({
  user: state.requestUserDataReducer.data,
  selectedProject: state.getSelectedProjectReducer.data,
  settings: state.requestGeneralSettingsReducer.data
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)
